// Generated by ts-to-zod
import { z } from "zod";

export const productNameSchema = z.string();

export const productFamilySchema = z.string().nullable();

export const productManufacturerSchema = z.string().nullable();

export const rootDeviceSchema = z.string().nullable();

export const disabledSchema = z.boolean();

export const revisionSchema = z.string().nullable();

export const nameSchema = z.string().nullable();

export const repoUrlSchema = z.string().nullable();

export const fromVersionSchema = z.string().nullable();

export const actionSchema = z.literal("add");

export const name1Schema = z.string();

export const pathSchema = z.string();

export const remoteSchema = z.string().nullable();

export const revision1Schema = z.string().nullable();

export const action1Schema = z.literal("extend");

export const name2Schema = z.string();

export const revision2Schema = z.string().nullable();

export const remote1Schema = z.string().nullable();

export const action2Schema = z.literal("remove");

export const name3Schema = z.string();

export const addManifestProjectSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        action: actionSchema,
        name: name1Schema,
        path: pathSchema,
        remote: remoteSchema.optional(),
        revision: revision1Schema.optional(),
    }),
);

export const extendManifestProjectSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        action: action1Schema,
        name: name2Schema,
        revision: revision2Schema.optional(),
        remote: remote1Schema.optional(),
    }),
);

export const removeManifestProjectSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        action: action2Schema,
        name: name3Schema,
    }),
);

export const name4Schema = z.string();

export const fetchSchema = z.string();

export const manifestRemoteSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        name: name4Schema,
        fetch: fetchSchema,
    }),
);

export const urlSchema = z.string();

export const variableKeySchema = z.string();

export const usernameSchema = z.string();

export const baseUrlSchema = z.string().nullable();

export const credentialSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        url: urlSchema,
        variableKey: variableKeySchema,
        username: usernameSchema,
        baseUrl: baseUrlSchema.optional(),
    }),
);

export const buildTargetSchema = z.string().nullable();

export const buildScriptSchema = z.string().nullable();

export const productMakefilePathSchema = z.string().nullable();

export const lineageBuildSchema = z.boolean();

export const additionalMakeTargetsSchema = z.array(z.unknown());

export const extraTargetFilesSchema = z.array(z.string());

export const path1Schema = z.string();

export const optionalSchema = z.boolean();

export const inheritProductSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        path: path1Schema,
        optional: optionalSchema.optional(),
    }),
);

export const skipSchema = z.boolean();

export const runTestsSchema = z.boolean().nullable();

export const customCertsSchema = z.string().nullable();

export const gptSupportSchema = z.boolean().nullable();

export const abOtaSchema = z.boolean();

export const buildOtaSchema = z.boolean();

export const disableIncrementalSchema = z.boolean();

export const incrementalFromVersionsSchema = z.array(z.string());

export const installerSchema = z.string().nullable();

export const wipeUserdataSchema = z.boolean();

export const signedFilesSchema = z.boolean();

export const path2Schema = z.string();

export const contentSchema = z.string().nullable();

export const sourceIdSchema = z.string().nullable();

export const profileSchema = z.string().nullable();

export const pciPassthroughSchema = z.string().nullable();

export const extraConfigSchema = z.string().nullable();

export const kernelCommandlineAppendsSchema = z.string().nullable();

export const sourceId1Schema = z.string().nullable();

export const sourceId2Schema = z.string();

export const buildVariantSchema = z.union([z.literal("user"), z.literal("userdebug"), z.literal("eng")]);

export const compatibilitySchema = z.string();

export const name5Schema = z.string();

export const includeSchema = z.boolean();

export const typeSchema = z.literal("prebuilt_app");

export const name6Schema = z.string();

export const sourceId3Schema = z.string();

export const partitionSchema = z.union([
    z.literal("product"),
    z.literal("system"),
    z.literal("system_ext"),
    z.literal("odm"),
    z.literal("vendor"),
]);

export const privilegedSchema = z.boolean();

export const certificateSchema = z.string().nullable();

export const overrideSchema = z.string().nullable();

export const type1Schema = z.literal("prebuilt_executable");

export const name7Schema = z.string();

export const sourceId4Schema = z.string();

export const partition1Schema = z.union([
    z.literal("product"),
    z.literal("system"),
    z.literal("system_ext"),
    z.literal("odm"),
    z.literal("vendor"),
]);

export const type2Schema = z.literal("remove_override");

export const name8Schema = z.string();

export const type3Schema = z.literal("existing_module");

export const name9Schema = z.string();

export const type4Schema = z.literal("selinux_module");

export const path3Schema = z.string();

export const policySchema = z.union([
    z.literal("system_ext_private"),
    z.literal("system_ext_public"),
    z.literal("vendor"),
    z.literal("odm"),
]);

export const applicationModuleSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        type: typeSchema,
        name: name6Schema,
        sourceId: sourceId3Schema,
        partition: partitionSchema.optional(),
        privileged: privilegedSchema.optional(),
        certificate: certificateSchema.optional(),
        override: overrideSchema.optional(),
    }),
);

export const executableModuleSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        type: type1Schema,
        name: name7Schema,
        sourceId: sourceId4Schema,
        partition: partition1Schema.optional(),
    }),
);

export const prebuiltBootAnimationModuleSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        type: z.literal("prebuilt_bootanimation"),
        name: name6Schema,
        sourceId: sourceId3Schema,
    }),
);

export const removeModuleSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        type: type2Schema,
        name: name8Schema,
    }),
);

export const existingModuleSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        type: type3Schema,
        name: name9Schema,
    }),
);

export const seLinuxModuleSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        type: type4Schema,
        path: path3Schema,
        policy: policySchema,
    }),
);

export const downloadableFileModuleSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        type: z.literal("downloadable_file"),
        name: z.string(),
        sourceId: z.string(),
    }),
);

export const overlaySchema = z.record(z.string(), z.unknown()).and(
    z.object({
        targetPackage: z.string(),
        resourcePath: z.string(),
        resourceName: z.string(),
        resourceType: z.union([
            z.literal("bool"),
            z.literal("string"),
            z.literal("integer"),
            z.literal("dimen"),
            z.literal("color"),
        ]),
        value: z.string(),
        targetName: z.string().optional().nullable(),
    }),
);

export const includeEmteriaFeaturesSchema = z.boolean().nullable();

export const provisioningIdSchema = z.number().nullable();

export const fileIdSchema = z.string().nullable();

export const type5Schema = z.string();

export const filenameSchema = z.string().nullable();

export const versionSchema = z.string().nullable();

export const workspaceIdSchema = z.number().nullable();

export const keySchema = z.string();

export const valueSchema = z.string();

export const version1Schema = z.string();

export const stepsSchema = z.array(z.string()).nullable();

export const containerImageSchema = z.string().nullable();

export const osbuilderVersionSchema = z.string().nullable();

export const schemaVersionSchema = z.string();

export const signingSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        skip: skipSchema.optional(),
        runTests: runTestsSchema.optional(),
        customCerts: customCertsSchema.optional(),
    }),
);

export const packagingSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        gptSupport: gptSupportSchema.optional(),
    }),
);

export const otaSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        abOta: abOtaSchema.optional(),
        buildOta: buildOtaSchema.optional(),
        disableIncremental: disableIncrementalSchema.optional(),
        incrementalFromVersions: incrementalFromVersionsSchema.optional(),
        installer: installerSchema.optional(),
        wipeUserdata: wipeUserdataSchema.optional(),
    }),
);

export const uploadingSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        signedFiles: signedFilesSchema.optional(),
    }),
);

export const modulesSchema = z.array(
    z.union([
        applicationModuleSchema,
        executableModuleSchema,
        prebuiltBootAnimationModuleSchema,
        removeModuleSchema,
        existingModuleSchema,
        seLinuxModuleSchema,
        downloadableFileModuleSchema,
    ]),
);

export const overlaysSchema = z.array(overlaySchema).nullable();

export const projectsSchema = z.array(
    z.union([addManifestProjectSchema, extendManifestProjectSchema, removeManifestProjectSchema]),
);

export const remotesSchema = z.array(manifestRemoteSchema);

export const credentialsSchema = z.array(credentialSchema);

export const productInheritsSchema = z.array(inheritProductSchema);

export const rpiBootloaderAdditionSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        path: path2Schema,
        content: contentSchema.optional(),
        sourceId: sourceIdSchema.optional(),
    }),
);

export const hypervisorConfigurationSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        profile: profileSchema.optional(),
        pciPassthrough: pciPassthroughSchema.optional(),
        extraConfig: extraConfigSchema.optional(),
        kernelCommandlineAppends: kernelCommandlineAppendsSchema.optional(),
        sourceId: sourceId1Schema.optional(),
    }),
);

export const bootAnimation1Schema = z.record(z.string(), z.unknown()).and(
    z.object({
        sourceId: sourceId2Schema,
    }),
);

export const emteriaAppSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        name: name5Schema,
        include: includeSchema.optional(),
    }),
);

export const fileSourceSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        fileId: fileIdSchema.optional(),
        type: type5Schema.optional(),
        filename: filenameSchema.optional(),
        version: versionSchema.optional(),
        workspaceId: workspaceIdSchema.optional(),
    }),
);

export const systemPropertySchema = z.record(z.string(), z.unknown()).and(
    z.object({
        key: keySchema,
        value: valueSchema,
    }),
);

export const bootloaderAdditionsSchema = z.array(rpiBootloaderAdditionSchema).nullable();

export const hypervisorSchema = hypervisorConfigurationSchema.nullable();

export const bootAnimationSchema = bootAnimation1Schema.nullable();

export const emteriaAppsSchema = z.array(emteriaAppSchema).nullable();

export const systemPropertiesSchema = z.array(systemPropertySchema).nullable();

export const manifestSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        disabled: disabledSchema.optional(),
        revision: revisionSchema.optional(),
        name: nameSchema.optional(),
        repoUrl: repoUrlSchema.optional(),
        fromVersion: fromVersionSchema.optional(),
        projects: projectsSchema.optional(),
        remotes: remotesSchema.optional(),
        credentials: credentialsSchema.optional(),
    }),
);

export const buildingSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        buildTarget: buildTargetSchema.optional(),
        buildScript: buildScriptSchema.optional(),
        productMakefilePath: productMakefilePathSchema.optional(),
        lineageBuild: lineageBuildSchema.optional(),
        additionalMakeTargets: additionalMakeTargetsSchema.optional(),
        extraTargetFiles: extraTargetFilesSchema.optional(),
        productInherits: productInheritsSchema.optional(),
    }),
);

export const sourcesSchema = z.record(z.string(), fileSourceSchema);

export const rpiSettingsSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        bootloaderAdditions: bootloaderAdditionsSchema.optional(),
    }),
);

export const celadonSettingsSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        hypervisor: hypervisorSchema.optional(),
    }),
);

export const rpiSchema = rpiSettingsSchema.nullable();

export const celadonSchema = celadonSettingsSchema.nullable();

export const deviceSpecificSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        rpi: rpiSchema.optional(),
        celadon: celadonSchema.optional(),
    }),
);

export const osBuilderConfigSchema = z.record(z.string(), z.unknown()).and(
    z.object({
        productName: productNameSchema.optional(),
        productFamily: productFamilySchema.optional(),
        productManufacturer: productManufacturerSchema.optional(),
        rootDevice: rootDeviceSchema.optional(),
        manifest: manifestSchema.optional(),
        building: buildingSchema.optional(),
        signing: signingSchema.optional(),
        packaging: packagingSchema.optional(),
        ota: otaSchema.optional(),
        uploading: uploadingSchema.optional(),
        deviceSpecific: deviceSpecificSchema.optional(),
        bootAnimation: bootAnimationSchema.optional(),
        buildVariant: buildVariantSchema.optional(),
        compatibility: compatibilitySchema.optional(),
        emteriaApps: emteriaAppsSchema.optional(),
        modules: modulesSchema.optional(),
        overlays: overlaysSchema.optional(),
        includeEmteriaFeatures: includeEmteriaFeaturesSchema.optional(),
        provisioningId: provisioningIdSchema.optional(),
        sources: sourcesSchema.optional(),
        systemProperties: systemPropertiesSchema.optional(),
        version: version1Schema.optional(),
        steps: stepsSchema.optional(),
        containerImage: containerImageSchema.optional(),
        osbuilderVersion: osbuilderVersionSchema.optional(),
        schemaVersion: schemaVersionSchema.optional(),
    }),
);
